'use strict';

angular.module('amexReconciliationApp')
  .component('matchedReceiptTile', {
    bindings: {
      receipt: '<',
      transaction: '<',
      onDelete: '&'
    },
    templateUrl: 'scripts/views/components/matched-receipt-tile.html',
    controller: function (ReceiptService) {
      var self = this;

      self.isReceiptViewable = ReceiptService.isReceiptViewable;

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/matchedReceiptTile.js
// module id = 457
// module chunks = 0